import { render, staticRenderFns } from "./ViewEmail.vue?vue&type=template&id=3cdafb90&scoped=true"
import script from "./ViewEmail.vue?vue&type=script&lang=js"
export * from "./ViewEmail.vue?vue&type=script&lang=js"
import style0 from "./ViewEmail.vue?vue&type=style&index=0&id=3cdafb90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdafb90",
  null
  
)

export default component.exports